import { render, staticRenderFns } from "./PageVR.vue?vue&type=template&id=8145d830"
import script from "./PageVR.vue?vue&type=script&lang=js"
export * from "./PageVR.vue?vue&type=script&lang=js"
import style0 from "./PageVR.vue?vue&type=style&index=0&id=8145d830&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports